import PublicMainFooter from "components/footers/PublicMainFooter";
import EmployerMainNav from "components/navigations/EmployerNavs/EmployerMainNav";
import React from "react";
import { Outlet } from "react-router-dom";

export default function PublicEmployerFilter() {
  return (
    <div>
      <EmployerMainNav />
      <Outlet />
      <PublicMainFooter />
    </div>
  );
}
